import { Controller } from "@hotwired/stimulus";

/**
 * Toggles element visibility based on select value.
 *
 * Usage:
 * 1. Add controller to container: data-controller="toggle-visibility"
 * 2. Set trigger select: data-toggle-visibility-target="trigger"
 * 3. Set content to toggle: data-toggle-visibility-target="content"
 * 4. Configure show condition: data-toggle-visibility-show-when-value="desiredValue"
 *
 * Example:
 * <div data-controller="toggle-visibility" data-toggle-visibility-show-when-value="canceled">
 *   <select data-toggle-visibility-target="trigger">
 *     <option value="active">Active</option>
 *     <option value="canceled">Canceled</option>
 *   </select>
 *   <div data-toggle-visibility-target="content">Shows when canceled</div>
 * </div>
 */
export default class extends Controller {
  static targets = ["trigger", "content"];
  static values = {
    showWhen: String,
  };

  connect() {
    this.toggle();
  }

  toggle() {
    const shouldShow = this.triggerTarget.value === this.showWhenValue;
    this.contentTarget.classList.toggle("hidden", !shouldShow);
  }
}
